"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Tabs = function (_a) {
    var methods = _a.methods, method = _a.method, setMethod = _a.setMethod;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.methods) }, methods.map(function (m) { return (react_1.default.createElement("div", { key: m.name || m.label, className: "".concat(styles_module_scss_1.default.method, " ").concat(styles_module_scss_1.default[m.key], " ").concat(m.stroke ? styles_module_scss_1.default.stroke : '', " ").concat((method === null || method === void 0 ? void 0 : method.slug) === m.slug ? styles_module_scss_1.default.active : ''), onClick: function () { return setMethod(m.slug); } },
            react_1.default.createElement("span", { className: styles_module_scss_1.default.customIcon }),
            react_1.default.createElement(m.Icon, null),
            " ",
            m.name || m.label)); }))));
};
exports.default = Tabs;
